import StyledAutocomplete2 from "./StyledAutocomplete2";  

export default StyledAutocomplete2;
